/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AcademicProgram,
    AcademicProgramFromJSON,
    AcademicProgramToJSON,
    BusinessSectors,
    BusinessSectorsFromJSON,
    BusinessSectorsToJSON,
    CompanyFixtureItem,
    CompanyFixtureItemFromJSON,
    CompanyFixtureItemToJSON,
    ContractType,
    ContractTypeFromJSON,
    ContractTypeToJSON,
    FormativeFamilies,
    FormativeFamiliesFromJSON,
    FormativeFamiliesToJSON,
    Modality,
    ModalityFromJSON,
    ModalityToJSON,
    Schedule,
    ScheduleFromJSON,
    ScheduleToJSON,
    State,
    StateFromJSON,
    StateToJSON,
} from '../models';

/**
 * 
 */
export class FixturesApi extends runtime.BaseAPI {

    /**
     * Lista de cursos
     */
    async fixturesAcademicProgramsGetRaw(): Promise<runtime.ApiResponse<Array<AcademicProgram>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/fixtures/academic_programs`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AcademicProgramFromJSON));
    }

    /**
     * Lista de cursos
     */
    async fixturesAcademicProgramsGet(): Promise<Array<AcademicProgram>> {
        const response = await this.fixturesAcademicProgramsGetRaw();
        return await response.value();
    }

    /**
     * Lista los sectores
     */
    async fixturesBusinessSectorsGetRaw(): Promise<runtime.ApiResponse<Array<BusinessSectors>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/fixtures/business_sectors`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BusinessSectorsFromJSON));
    }

    /**
     * Lista los sectores
     */
    async fixturesBusinessSectorsGet(): Promise<Array<BusinessSectors>> {
        const response = await this.fixturesBusinessSectorsGetRaw();
        return await response.value();
    }

    /**
     * Lista los empresas para selector
     */
    async fixturesCompaniesGetRaw(): Promise<runtime.ApiResponse<Array<CompanyFixtureItem>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/fixtures/companies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CompanyFixtureItemFromJSON));
    }

    /**
     * Lista los empresas para selector
     */
    async fixturesCompaniesGet(): Promise<Array<CompanyFixtureItem>> {
        const response = await this.fixturesCompaniesGetRaw();
        return await response.value();
    }

    /**
     * Lista de tipos de contrato
     */
    async fixturesContractTypesGetRaw(): Promise<runtime.ApiResponse<Array<ContractType>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/fixtures/contract_types`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ContractTypeFromJSON));
    }

    /**
     * Lista de tipos de contrato
     */
    async fixturesContractTypesGet(): Promise<Array<ContractType>> {
        const response = await this.fixturesContractTypesGetRaw();
        return await response.value();
    }

    /**
     * Listado de familias
     */
    async fixturesFormativeFamiliesGetRaw(): Promise<runtime.ApiResponse<Array<FormativeFamilies>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/fixtures/formative_families`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FormativeFamiliesFromJSON));
    }

    /**
     * Listado de familias
     */
    async fixturesFormativeFamiliesGet(): Promise<Array<FormativeFamilies>> {
        const response = await this.fixturesFormativeFamiliesGetRaw();
        return await response.value();
    }

    /**
     * Listado de modalities
     */
    async fixturesModalitiesGetRaw(): Promise<runtime.ApiResponse<Array<Modality>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/fixtures/modalities`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ModalityFromJSON));
    }

    /**
     * Listado de modalities
     */
    async fixturesModalitiesGet(): Promise<Array<Modality>> {
        const response = await this.fixturesModalitiesGetRaw();
        return await response.value();
    }

    /**
     * Lista de jornadas laborales
     */
    async fixturesSchedulesGetRaw(): Promise<runtime.ApiResponse<Array<Schedule>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/fixtures/schedules`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ScheduleFromJSON));
    }

    /**
     * Lista de jornadas laborales
     */
    async fixturesSchedulesGet(): Promise<Array<Schedule>> {
        const response = await this.fixturesSchedulesGetRaw();
        return await response.value();
    }

    /**
     * Lista de provincias
     */
    async fixturesStatesGetRaw(): Promise<runtime.ApiResponse<Array<State>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/fixtures/states`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StateFromJSON));
    }

    /**
     * Lista de provincias
     */
    async fixturesStatesGet(): Promise<Array<State>> {
        const response = await this.fixturesStatesGetRaw();
        return await response.value();
    }

}
